// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"214ddc82","82":"214ddc82","365":"a13246d1","644":"214ddc82","818":"214ddc82","995":"0c939876"}[chunkId] + ".chunk.css";
};